import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { ViewScopeService } from './view-scope.service';
import { Router } from '@angular/router';
import { retry } from 'rxjs';
import { PrimeNG } from 'primeng/config';

import { DICT } from './account-api.constants';

@Injectable({
	providedIn: 'root'
})
export class TranslateService {
	private userId = 0;
	private url = '';
	private _dictionary: object | any;

	private readonly STORAGE_KEY = 'user_dictionary';

	public get dictionary(): any {
		return this._dictionary ? this._dictionary : [];
	}

	private _isLoaded: boolean | any;
	public get isLoaded(): boolean | any {
		return this._isLoaded;
	}
	public set isLoaded(v: boolean | any) {
		this._isLoaded = v;
	}

	constructor(
		private ajaxServ: AjaxService,
		private viewScopeService: ViewScopeService,
		private router: Router,
		private primeNGConfig: PrimeNG
	) {
		this.url = this.ajaxServ.getBaseOfApi();
		console.log("URL returned: ", this.url);

		// Try loading dictionary from sessionStorage first
		const cachedDict = sessionStorage.getItem(this.STORAGE_KEY);
		if (cachedDict) {
			this._dictionary = JSON.parse(cachedDict);
			this.isLoaded = true;
			this.applyPrimeNgFilterTranslation();
		}

		if (this.url != null) {
			this.loadDictionary(); // Still fetch from API to ensure freshness
		}
	}

	public loadDictionary(): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			this.isLoaded = false;

			let id: any = this.viewScopeService.getCurrentOpertaingUserId().toString();
			if (id > 0) {
				console.log("Loading Dict, user id is: ", id);
				this.userId = id;
			}

			this.getDictionary()
				.pipe(retry(3))
				.subscribe({
					next: (response) => {
						this._dictionary = response;
						this.isLoaded = true;
						sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(response));
						this.applyPrimeNgFilterTranslation();
						resolve();
					},
					error: (error) => {
						this.router.navigate(['/error', { code: -1 }]);
						reject(error);
					},
					complete: () => {
						if (!this.isLoaded) {
							// Optional logic
						}
					},
				});
		});
	}

	// Maps the app's dictionary onto PrimeNG's built-in column filter texts (match modes, Apply/Clear, etc.)
	private applyPrimeNgFilterTranslation(): void {
		const dict = this.dictionary;
		this.primeNGConfig.setTranslation({
			startsWith: dict['FILTER_STARTS_WITH'] || 'Starts with',
			contains: dict['FILTER_CONTAINS'] || 'Contains',
			notContains: dict['FILTER_NOT_CONTAINS'] || 'Not contains',
			endsWith: dict['FILTER_ENDS_WITH'] || 'Ends with',
			equals: dict['FILTER_EQUALS'] || 'Equals',
			notEquals: dict['FILTER_NOT_EQUALS'] || 'Not equals',
			noFilter: dict['FILTER_NO_FILTER'] || 'No Filter',
			lt: dict['FILTER_LESS_THAN'] || 'Less than',
			lte: dict['FILTER_LESS_THAN_OR_EQUAL'] || 'Less than or equal to',
			gt: dict['FILTER_GREATER_THAN'] || 'Greater than',
			gte: dict['FILTER_GREATER_THAN_OR_EQUAL'] || 'Greater than or equal to',
			is: dict['FILTER_IS'] || 'Is',
			isNot: dict['FILTER_IS_NOT'] || 'Is not',
			before: dict['FILTER_BEFORE'] || 'Before',
			after: dict['FILTER_AFTER'] || 'After',
			dateIs: dict['FILTER_DATE_IS'] || 'Date is',
			dateIsNot: dict['FILTER_DATE_IS_NOT'] || 'Date is not',
			dateBefore: dict['FILTER_DATE_BEFORE'] || 'Date is before',
			dateAfter: dict['FILTER_DATE_AFTER'] || 'Date is after',
			clear: dict['FILTER_CLEAR'] || 'Clear',
			apply: dict['FILTER_APPLY'] || 'Apply',
			matchAll: dict['FILTER_MATCH_ALL'] || 'Match All',
			matchAny: dict['FILTER_MATCH_ANY'] || 'Match Any',
			addRule: dict['FILTER_ADD_RULE'] || 'Add Rule',
			removeRule: dict['FILTER_REMOVE_RULE'] || 'Remove Rule',
			emptyFilterMessage: dict['FILTER_EMPTY_MESSAGE'] || 'No results found',
			emptyMessage: dict['TABLE_EMPTY_MESSAGE'] || 'No available data'
		});
	}


	private getDictionary() 
	{
		const langDefault = 'HE';
		let lang = this.viewScopeService.getCurrentOpertaingUserId().toString() === '0' ? localStorage.getItem('lang')?.toUpperCase() : langDefault;
		if (!lang) lang = langDefault;
		const url = this.url + DICT + this.userId + '/' + lang;
		return this.ajaxServ.getData(url);
	}
}
